import { createContext } from "react";

const TransfersContext = createContext({});

export default TransfersContext;
